import { apiClient } from './client';
import type { User } from '@/types/auth';

export interface CreateUserPayload {
  username: string;
  password?: string;
  role: 'call_center' | 'accountant' | 'manager' | 'driver';
  canExport?: boolean;
  englishName?: string;
  arabicName?: string;
}

export interface UpdateUserPayload {
  password?: string;
  role?: 'call_center' | 'accountant' | 'manager' | 'driver';
  canExport?: boolean;
  isActive?: boolean;
  englishName?: string;
  arabicName?: string;
}

export interface UsersResponse {
    success: boolean;
    data: User[];
}

export interface UserResponse {
    success: boolean;
    data: User;
}

export const usersAPI = {
  getAll: () => 
    apiClient.get<UsersResponse>('/users'),

  create: (data: CreateUserPayload) => 
    apiClient.post<UserResponse>('/users', data),

  update: (id: number, data: UpdateUserPayload) => 
    apiClient.put<UserResponse>(`/users/${id}`, data),

  delete: (id: number) => 
    apiClient.delete(`/users/${id}`),
};
